import { Select, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import type { PartnerShipOption } from '@shipium-corp/shipium-ts-types';
import logo from '~/assets/symbol.png';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

const { Text } = Typography;

export const SHIP_OPTIONS_QUERY_KEY = ['shipOptions'];

export const ShipOptionSelect = ({ ...props }) => {
  const { data: rawData, isLoading } = useQuery({
    queryKey: SHIP_OPTIONS_QUERY_KEY,
    queryFn: () =>
      GatewayAxiosClient.get('/partner-management-proxy/api/v1/partners/shipOptions?isShipiumShipOption=true'),
    refetchOnWindowFocus: false,
  });
  // Guard against a non-array payload and sort a copy rather than mutating the react-query cache.
  const data = rawData?.data;
  const shipOptions: PartnerShipOption[] = Array.isArray(data)
    ? [...data].sort((a, b) => (a.partnerId === 'shipium' ? 0 : a.name.localeCompare(b.name)))
    : [];

  const searchMap = shipOptions.reduce<Record<string, string>>((acc, val) => {
    const searchText = [val.name, val.partnerProvidedId, val.shipOptionEntries?.[0]?.serviceMethods?.join('')]
      .join('')
      .toLowerCase();
    acc[val.partnerProvidedId] = searchText;
    return acc;
  }, {});

  return (
    <Select
      {...props}
      loading={isLoading}
      showSearch={true}
      optionFilterProp="children"
      filterOption={(input: string, option) => {
        if (option?.value && searchMap[option?.value]) {
          const searchText = searchMap[option?.value];
          return searchText.includes(input.toLowerCase());
        }
        return false;
      }}
    >
      {shipOptions.map((val) => {
        const methods = val.shipOptionEntries?.[0]?.serviceMethods || [];
        const methodDescription = methods.length === 1 ? 'method' : 'methods';
        return (
          <Select.Option key={val.shipOptionId} value={val.partnerProvidedId}>
            <div>
              <b>{val.name}</b>
              {val.partnerId === 'shipium' && (
                <img src={logo} width="20px" alt="Shipium Default" style={{ marginLeft: 5 }} />
              )}
            </div>
            <div>
              <Text code>{val.partnerProvidedId}</Text> ({methods.length} {methodDescription})
            </div>
          </Select.Option>
        );
      })}
    </Select>
  );
};
